import { render, staticRenderFns } from "./LabelSelect.vue?vue&type=template&id=1c4ff8fe&scoped=true"
import script from "./LabelSelect.vue?vue&type=script&lang=js"
export * from "./LabelSelect.vue?vue&type=script&lang=js"
import style0 from "./LabelSelect.vue?vue&type=style&index=0&id=1c4ff8fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4ff8fe",
  null
  
)

export default component.exports